import { cleanVariantGID, cleanProductGID } from '@/utils/cleanGIDs';
import { getUserData } from './cart-events';

export async function elevarViewItemList(cardProducts, slug) {
  if (cardProducts.length > 0) {
    const impressions = [];
    cardProducts.forEach((product, index) => {
      impressions.push({
        id: product.variants[0].sku, // SKU
        name: product.title, // Product title
        brand: 'Leesa',
        category: product?.productType || '',
        price: parseFloat(product.variants[0].price.amount).toFixed(2), // Price
        list: `/collections/${slug}`, // Not required for dl_view_cart; The list the product is displayed in
        product_id: cleanProductGID(product.id), // The product_id
        variant: product.variants[0].title, // Variant title
        variant_id: cleanVariantGID(product.variants[0].id), // id or variant_id
        compare_at_price: parseFloat(
          product.variants[0].compareAtPrice.amount
        ).toFixed(2), // If available
        position: index + 1 // position in the list of search results, collection views and position in cart indexed starting at 1
      });
    });
    const userdata = getUserData();

    if (window.ElevarDataLayer) {
      window.ElevarDataLayer.push({
        event: 'dl_view_item_list',
        user_properties: userdata,
        ecommerce: {
          currencyCode: 'USD',
          impressions: impressions // See impressions array below
        }
      });
    }
  }
}
